module.exports = __webpack_public_path__ + "img/full1-min.f9e71dd3.png";